import { useCompanyMembers } from '../hooks';

import { CompanyMemberActions } from './CompanyMemberActions';
import { CompanyMemberList } from './CompanyMemberList';

export function CompanyMembers() {
  const { pageTitle } = useCompanyMembers();

  return (
    <div className="flex flex-col gap-7 my-6">
      <div className="flex items-center justify-between">
        <h4 className="typo-h4-bold text-secondary">{pageTitle}</h4>
        <CompanyMemberActions />
      </div>
      <CompanyMemberList />
    </div>
  );
}
export default CompanyMembers;
